/**
 * `#RRGGBB` 색을 흰색 방향으로 섞어 더 밝게 만든다.
 * @param hex6 `#` 포함 6자리 16진 (대소문자 무관)
 * @param amount 0~1, 예: 0.5 → 원색과 흰색을 1:1 블렌드
 */
export function lightenRgbHexTowardWhite(hex6: string, amount: number): string {
  const h = hex6.trim();
  if (!/^#[0-9A-Fa-f]{6}$/.test(h)) return h;
  const t = Math.min(1, Math.max(0, amount));
  const r = parseInt(h.slice(1, 3), 16);
  const g = parseInt(h.slice(3, 5), 16);
  const b = parseInt(h.slice(5, 7), 16);
  const rr = Math.round(r + (255 - r) * t);
  const gg = Math.round(g + (255 - g) * t);
  const bb = Math.round(b + (255 - b) * t);
  return `#${[rr, gg, bb].map((x) => x.toString(16).padStart(2, '0')).join('')}`.toUpperCase();
}
